import DownloadGtmContainerComponent from '../../components/download-gtm-container';

export const DownloadMetaGtmContainer = () => {
  return <DownloadGtmContainerComponent platformName="Meta" />;
};

export default DownloadMetaGtmContainer;
